const IMAGE_STATUS = {
  ACCEPTED: 'accepted',
  AUTOACCEPTED: 'autoaccepted',
  CREATED: 'created',
  REJECTED: 'rejected',
  CLONED: 'cloned'
};

export default IMAGE_STATUS;
